import axios from 'axios';
import { getAuthToken } from './auth';

export const API_URL_BASE = process.env.REACT_APP_API_BASE_URL; 

const createAxiosInstance = (url) => {
    // Crear una instancia de Axios con la configuración base
    const api = axios.create({
      baseURL: API_URL_BASE + url,
      withCredentials: true
    });
    
    // Configurar un interceptor para agregar el token de autorización a cada solicitud
    api.interceptors.request.use(
      config => {
        const token = getAuthToken();
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
      },
      error => {
        return Promise.reject(error);
      }
    );
    
    return api;
  };
  
  export default createAxiosInstance;
